module.exports = __webpack_public_path__ + "static/media/KdsLandingPage.38f74fbc.png";